import recentlyViewed from "./widgets/recentlyViewed";

class widgets {
  constructor() {
    $(document).ready(() => {
      this.shopTheLook();
      this.customerCare();
      this.threeColSlider();
      this.circles();
      this.videoBox();
      this.productSlotSlider();
      this.rellax();
      this.aos();
      recentlyViewed.run();
    });
  }

  shopTheLook() {
    const $slides = $(".slides");
    const owl = $slides.owlCarousel({
      loop: true,
      nav: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 3
        }
      }
    });

    /*owl.on("changed.owl.carousel", event => {
      if (Foundation.MediaQuery.current !== "small") return;
      const $parent = $slides.parent(".widget-3-col-img-shopbylook");
      if ($parent.length) {
        const $bigLabel = $parent.find(".big-text");
        $bigLabel.stop(true).animate(
          {
            textIndent: -((100 / event.page.count) * event.page.index) + "%"
          },
          1000
        );
      }
    });*/

    if (["medium"].indexOf(Foundation.MediaQuery.current) > -1) {
      setTimeout(() => {
        const el = $(".widget-3-col-img-shopbylook [data-rellax]")[0];
        const rellax = new Rellax(el, {
          center: $(el).data("rellax-center")
        });
      }, 1000);
    }
  }

  customerCare() {
    $(".widget-customer-care").each((i, el) => {
      const $el = $(el);
      $el.addClass("hide");

      // TR-2175 remove empty card items (localization)
      $el.children("div.box:not(:has(a))").remove();

      const cards = $el.children(".box").remove();
      const cardsLength = cards.length;
      const startPosition = cardsLength % 2 !== 0 ? parseInt((cardsLength / 2).toFixed()) : 0;
      const center = startPosition > 0;
      const owlConfig = {
        items: 1,
        center: true,
        loop: cardsLength > 2, // TR-2175 le card si ripetono in successione anche se ne mettiamo 1 o 2
        dots: false,
        margin: 40,
        autoWidth: true,
        slideBy: 1,
        responsive: {
          600: {
            items: 5,
            center: true,
            loop: true,
            autoWidth: true
          },
          1000: {
            items: center ? 5 : cardsLength,
            center,
            loop: false,
            autoWidth: false
          }
        }
      };

      if (center) {
        owlConfig.responsive[1000].startPosition = startPosition - 1;
      }

      // this is not really nice but us necessary to svoid all contate assets rework
      $el.append(
        '<div class="grid-container"><div class="widget-carousel"></div></div>'
      );
      cards.appendTo($el.find(".widget-carousel"));

      $el.find(".widget-carousel").owlCarousel(owlConfig);
      $el.removeClass("hide");

      $el.find("a").on("click.widgetCustomerCare", function(e) {

        const target = $(e.currentTarget);
        const eventAction = target.find("h5").text();
        dataLayer.push({
          event: "asyncAction",
          gaHitType: "event",
          event_category: "click_footer",
          event_action: eventAction,
          event_label: ""
        });
      });
    });
  }


  threeColSlider() {
    const $widgets = $(".widget-3-col-img-txt-img-slider");

    if (["small", "medium"].indexOf(Foundation.MediaQuery.current) > -1) {
      const images = $widgets.find(".image-left img");
      const texts = $widgets.find(".text .inner");

      const boxes = [];
      images.each((i, el) => {
        boxes.push(
          $('<div class="box" />')
            .append(el)
            .append(texts[i])
        );
      });
      $widgets.empty().append(boxes);

      $widgets.owlCarousel({
        items: 2,
        center: true,
        autoWidth: true,
        responsive: {
          0: {
            items: 1,
            margin: 20
          },
          480: {
            margin: 40
          },
          768: {
            margin: 15,
            autoWidth: false
          }
        }
      });
    } else {
      $widgets.each((i, el) => {
        const $widget = $(el);
        const count = $widget.find(".image-left .wrap img").length;
        $widget.find(".widget-total").text(count);
        $widget
          .find(".image-left .wrap, .image-right .wrap")
          .css("width", "100%");
        let current = 0;

        $widget.find(".text .inner").each((i, el) => {
          if (i) $(el).hide();
          $(el).addClass("text-" + i);
        });

        var move = () => {
          $widget.find(".widget-current").text(current + 1);

          let imageLeft = $widget.find(".image-left .wrap");
          let imageRight = $widget.find(".image-right .wrap");

          $widget.find(".image-left .wrap").css({
            left:
              -imageLeft
                .find("img")
                .first()
                .width() *
                current +
              "px"
          });

          $widget.find(".image-right .wrap").css({
            left:
              -imageRight
                .find("img")
                .first()
                .width() *
                current +
              "px"
          });

          $widget.find(".text .inner").hide();
          $widget.find(".text-" + current).fadeIn(1000);
        };

        $widget.find(".widget-next").click(() => {
          if (current + 1 >= count) return;
          current++;
          move();
        });

        $widget.find(".widget-prev").click(() => {
          if (current - 1 < 0) return;
          current--;
          move();
        });
      });
    }

    // Refresh page to re-render threeColSlider component on screen orientation changed
    // TODO: refactor threeColSlider component to be responsive (without page refresh)
    window.addEventListener("orientationchange", function() {
      window.location.reload(true);
    });
  }

  circles() {
    if (Foundation.MediaQuery.current !== "small") return;

    $(".widget-circles .items").owlCarousel({
      loop: true,
      nav: false,
      autoWidth: true,
      items: 3
    });

    $(".widget-circles .items .owl-item a").on("click", function(e) {
      var lang = $("html").attr("lang");
      var country = $("body").attr("data-country");
      var locale = lang + "_" + country;
      if (dataLayer && e.currentTarget && e.currentTarget.innerText) {
        var item = locale + "|" + e.currentTarget.innerText.toLowerCase();
        dataLayer.push({
          event: "asyncAction",
          gaHitType: "event",
          event_category: "pics_for_you",
          event_action: "click",
          event_label: item
        });
      }
    });
  }

  videoBox() {
    if (!$("[data-video]").length) return;

    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/player_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    const isDesktopDevice = Foundation.MediaQuery.is('xlarge up');

    function iOS() {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    function onPlayerReady(event) {
      event.target.playVideo();
    }

    const players = {};
    window.onYouTubePlayerAPIReady = () => {
      $("[data-video]").each((i, el) => {
        const videoID = $(el).data("video");
        $(el).append('<button class="play-btn">Play</button>');
        $(el).append(`<div class="video-wrapper" id="${videoID}"></div>`);

        setTimeout(() => {
          if (iOS()) {
            //Player initialization on iOS mobile devices 
            if (typeof players[videoID] === "undefined") {
              players[videoID] = new YT.Player(videoID, {
                height: "100%",
                width: "100%",
                videoId: videoID,
                playerVars: {
                  controls: 0,
                  disablekb: 1,
                  modestbranding: 1,
                  showinfo: 0,
                  playsinline: 0,
                  autoplay: 1,
                  rel: 0
                },
                events: {
                  'onReady': onPlayerReady,
                  onStateChange: state => {
                    if (state.data === YT.PlayerState.PLAYING) {
                      $(el)
                        .addClass("video-playing")
                        .removeClass("video-ended");
                    } else {
                      $(el)
                        .removeClass("video-playing")
                        .addClass("video-ended");
                    }
                  }
                }
              });
            }
        } else {
          if (!isDesktopDevice) {
            //Player initialization on Android mobile devices 
            if (typeof players[videoID] === "undefined") {
              players[videoID] = new YT.Player(videoID, {
                height: "100%",
                width: "100%",
                videoId: videoID,
                playerVars: {
                  controls: 0,
                  disablekb: 1,
                  modestbranding: 1,
                  showinfo: 0,
                  autoplay: 1,
                  rel: 0
                },
                events: {
                  onStateChange: state => {
                    if (state.data === YT.PlayerState.PLAYING) {
                      $(el)
                        .addClass("video-playing")
                        .removeClass("video-ended");
                    } else {
                      $(el)
                        .removeClass("video-playing")
                        .addClass("video-ended");
                    }
                  }
                }
              });
            }
          } else {
          //Player initialization on desktop devices 
          if (typeof players[videoID] === "undefined") {
            players[videoID] = new YT.Player(videoID, {
              height: "100%",
              width: "100%",
              videoId: videoID,
              playerVars: {
                controls: 0,
                disablekb: 1,
                modestbranding: 1,
                showinfo: 0,
                autoplay: 0,
                rel: 0
              },
              events: {
                onStateChange: state => {
                  if (state.data === YT.PlayerState.PLAYING) {
                    $(el)
                      .addClass("video-playing")
                      .removeClass("video-ended");
                  } else {
                    $(el)
                      .removeClass("video-playing")
                      .addClass("video-ended");
                  }
                }
              }
            });
          }
          }
        }
        }, 2000);



        $(el)
          .find(".play-btn")
          .on("click",
            {
              videoID,
              el
            },
            e => {
              players[e.data.videoID].playVideo();
            }
          );
      });
    };
  }
  productSlotSlider() {
    const $widget = $(".products-slot-slider");
    $widget
      .find(".widget-total")
      .text($(".products-slot-slider .slider > div").length);

    const slider = $widget.find(".slider").owlCarousel({
      items: 1,
      loop: false,
      nav: false,
      responsive: {
        0: {
          items: 2,
          margin: 10,
          dots: true
        },
        768: {
          items: 4,
          margin: 15,
          dots: false
        },
        1000: {
          items: 1,
          dots: false
        }
      }
    });

    slider.on("changed.owl.carousel", e => {
      $widget.find(".widget-current").text(e.item.index + 1);
    });

    $widget.find(".widget-ctrl .widget-next").click(e => {
      slider.trigger("next.owl.carousel");
    });
    $widget.find(".widget-ctrl .widget-prev").click(e => {
      slider.trigger("prev.owl.carousel");
    });
  }

  rellax() {
    if (
      !$("[data-rellax]").length ||
      ["small", "medium"].indexOf(Foundation.MediaQuery.current) > -1
    )
      return;
    $("[data-rellax]").each((i, el) => {
      setTimeout(() => {
        const rellax = new Rellax(el, {
          center: $(el).data("rellax-center")
        });
      });
    });
  }

  aos() {
    if (typeof AOS !== 'undefined') {
      AOS.init({
        disable: "phone"
      });
    }
  }
}

const Widgets = new widgets();
export default Widgets;


// WEBPACK FOOTER //
// ./assets/scripts/widgets.js